module.exports = {
    public: {
        companyName: "千乘镜像（北京）科技有限公司",
        shareWork: "分享我们的工作成果和科研文章",
    }
}